module.exports = __webpack_public_path__ + "static/media/CUYA_Web_LandingPage_QuoteBackground.badb22fe.jpg";